import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function blockMissionTrackingPas(id: number) {
  return restApiClient
    .url(constructApiUrl(API.missionTrackings.blockMissionTrackingPas.url, { id }))
    .post()
}
